module.exports = __webpack_public_path__ + "img/2015-03-22.7653646e.jpg";